import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ENDPOINTS, setAuthToken, isAuthenticated } from './config';

const Login = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If already logged in, redirect
    if (isAuthenticated()) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [navigate, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch(ENDPOINTS.LOGIN, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });

      const data = await response.json();

      if (response.ok) {
        setAuthToken(data.access_token);
        const from = location.state?.from?.pathname || '/';
        navigate(from, { replace: true });
      } else {
        setError(data.detail || "Incorrect password. If you're not Kate, go away.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Network error or server is down.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-dvh bg-emerald-50">
      <h2 className="text-2xl font-bold mb-4">Please confirm that you are Kate</h2>
      <form onSubmit={handleSubmit} className="flex flex-col items-center w-full max-w-xs">
        <label htmlFor="password-input" className="sr-only">Password</label>
        <input
          id="password-input"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          className="p-3 border border-gray-300 rounded mb-4 w-full"
          disabled={isLoading}
        />
        <button
          type="submit"
          disabled={isLoading}
          className={`px-4 py-3 bg-emerald-600 text-white rounded hover:bg-emerald-700 w-full font-semibold transition-colors ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {isLoading ? 'Checking...' : 'Login'}
        </button>
        {error && <p className="text-red-500 mt-4 text-center">{error}</p>}
      </form>
    </div>
  );
};

export default Login;
